// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.details[data-v-26a82102] {
  padding-top: 10px;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.details[data-v-26a82102] >  .container {
  height: unset;
}
.details .header-content[data-v-26a82102] {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 40px;
  padding-right: 20px;
}
.details .header-content .left[data-v-26a82102] {
  flex: 1;
}
.details .header-content .right[data-v-26a82102] {
  cursor: pointer;
}
.details .base-info[data-v-26a82102] {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  row-gap: 16px;
  width: 100%;
}
.details .base-info .base-info-item[data-v-26a82102] {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 32%;
  color: #000;
}
.details .base-info .base-info-item[data-v-26a82102]:nth-child(3n -1) {
  margin: 0 2%;
}
.details .base-info .base-info-item .label[data-v-26a82102] {
  width: 142px;
  text-align: right;
  margin-right: 16px;
}
.details .base-info .base-info-item .value[data-v-26a82102] {
  height: 32px;
  flex: 1;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 6px;
  border: 1px solid #2a7ca7;
}
.details .detail-content[data-v-26a82102] {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.details .detail-content[data-v-26a82102] .label-content {
  width: 100%;
}
.details .detail-content[data-v-26a82102] .content {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
  height: 700px;
}
.details .detail-content[data-v-26a82102] .content > div {
  flex: 1;
  width: 100%;
  height: 33%;
}
.details .detail-content[data-v-26a82102] .content > .center {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}
.details .detail-content[data-v-26a82102] .content > .center > div {
  flex: 1;
}
.details .detail-content[data-v-26a82102] .content .bottom {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/views/InvestmentEstimateSoftware/SchemeInvestmentEstimate/DesignDetail.vue","webpack://./DesignDetail.vue"],"names":[],"mappings":"AACA;EACE,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;ACAF;ADLA;EAOI,aAAA;ACCJ;ADRA;EAUI,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;ACCJ;ADhBA;EAiBM,OAAA;ACEN;ADnBA;EAoBM,eAAA;ACEN;ADtBA;EAwBI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;ACCJ;AD9BA;EA+BM,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;ACEN;ADDM;EACE,YAAA;ACGR;ADzCA;EAyCQ,YAAA;EACA,iBAAA;EACA,kBAAA;ACGR;AD9CA;EA8CQ,YAAA;EACA,OAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EACA,yBAAA;ACGR;ADxDA;EA0DI,aAAA;EACA,sBAAA;EACA,uBAAA;ACCJ;AD7DA;EA8DM,WAAA;ACEN;ADhEA;EAiEM,WAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;ACEN;ADzEA;EAyEQ,OAAA;EACA,WAAA;EACA,WAAA;ACGR;AD9EA;EA8EQ,WAAA;EACA,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,SAAA;ACGR;ADrFA;EAoFU,OAAA;ACIV;ADxFA;EAwFQ,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,SAAA;ACGR","sourcesContent":["\n.details {\n  padding-top: 10px;\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  > ::v-deep .container {\n    height: unset;\n  }\n  .header-content {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    width: 100%;\n    gap: 40px;\n    padding-right: 20px;\n    .left {\n      flex: 1;\n    }\n    .right {\n      cursor: pointer;\n    }\n  }\n  .base-info {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    row-gap: 16px;\n    width: 100%;\n    .base-info-item {\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      flex-wrap: wrap;\n      width: 32%;\n      color: #000;\n      &:nth-child(3n -1) {\n        margin: 0 2%;\n      }\n      .label {\n        width: 142px;\n        text-align: right;\n        margin-right: 16px;\n      }\n      .value {\n        height: 32px;\n        flex: 1;\n        background-color: #f5f5f5;\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        padding-left: 6px;\n        border: 1px solid #2a7ca7;\n      }\n    }\n  }\n  .detail-content {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    ::v-deep .label-content {\n      width: 100%;\n    }\n    ::v-deep .content {\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-start;\n      align-items: flex-start;\n      gap: 10px;\n      height: 700px;\n      > div {\n        flex: 1;\n        width: 100%;\n        height: 33%;\n      }\n      > .center {\n        width: 100%;\n        display: flex;\n        align-items: flex-start;\n        justify-content: flex-start;\n        gap: 10px;\n        > div {\n          flex: 1;\n        }\n      }\n      .bottom {\n        display: flex;\n        align-items: flex-start;\n        justify-content: flex-start;\n        gap: 10px;\n      }\n    }\n  }\n}\n",".details {\n  padding-top: 10px;\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n.details > ::v-deep .container {\n  height: unset;\n}\n.details .header-content {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  gap: 40px;\n  padding-right: 20px;\n}\n.details .header-content .left {\n  flex: 1;\n}\n.details .header-content .right {\n  cursor: pointer;\n}\n.details .base-info {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  row-gap: 16px;\n  width: 100%;\n}\n.details .base-info .base-info-item {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  width: 32%;\n  color: #000;\n}\n.details .base-info .base-info-item:nth-child(3n -1) {\n  margin: 0 2%;\n}\n.details .base-info .base-info-item .label {\n  width: 142px;\n  text-align: right;\n  margin-right: 16px;\n}\n.details .base-info .base-info-item .value {\n  height: 32px;\n  flex: 1;\n  background-color: #f5f5f5;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding-left: 6px;\n  border: 1px solid #2a7ca7;\n}\n.details .detail-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n.details .detail-content ::v-deep .label-content {\n  width: 100%;\n}\n.details .detail-content ::v-deep .content {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 10px;\n  height: 700px;\n}\n.details .detail-content ::v-deep .content > div {\n  flex: 1;\n  width: 100%;\n  height: 33%;\n}\n.details .detail-content ::v-deep .content > .center {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 10px;\n}\n.details .detail-content ::v-deep .content > .center > div {\n  flex: 1;\n}\n.details .detail-content ::v-deep .content .bottom {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
